"use strict";
var OnExpandViewComponentClick = function (clickEvent) {
    var clickedLinkElement = clickEvent.currentTarget;
    if (clickedLinkElement != null) {
        if (clickedLinkElement.innerText.charAt(0) === "+") {
            clickedLinkElement.innerText = '-' + clickedLinkElement.innerText.substring(1);
        }
        else {
            clickedLinkElement.innerText = '+' + clickedLinkElement.innerText.substring(1);
        }
    }
};
var allExpandVcLinks = document.getElementsByClassName("expand-vc-link");
for (var i = 0; i < allExpandVcLinks.length; i++) {
    allExpandVcLinks[i].addEventListener('click', OnExpandViewComponentClick, false);
}
